import ribbon from '../../images/ribbon.svg';

const Gr8 = () => {
  const data = [
    {
      title: "Comprehensive Skill & Interest Analysis",
      description: "We conduct scientifically designed tests to assess cognitive abilities, problem-solving skills, and personal inclinations."
    },
    {
      title: "Personalized Career Counseling",
      description: "Our expert counselors interpret assessment results and provide tailored career guidance."
    },
    {
      title: "Career Pathway Recommendations",
      description: "Based on assessment insights, we suggest the most suitable higher education courses, universities, and professional fields."
    },
    {
      title: "Step-by-Step Guidance",
      description: "From choosing the right stream to securing admissions in top universities abroad (USA, UK, Canada, Australia, and Europe), we support students at every stage."
    }
  ]
  return (
    <div id="gr8">
      <img src={ribbon} alt="Gr8 Appers" />
      <div className="container">
        <h3>How <b>Gr8 Appers</b> <br/>Helps You Choose the Right Career</h3>
        <p className="mdText">At Gr8 Appers, we use AI-driven psychometric assessments to evaluate students’ aptitudes, personalities, and interests. Our process includes:</p>
        <div className="gr8-cards">
          {data.map((item, index) => (
            <div className="gr8-card" key={index}>
              <b>{item.title}</b>
              <span>{item.description}</span>
            </div>
          ))}
      </div>

    </div>
    </div>
  );
};

export default Gr8;
